import { useMemo } from "react";
import { Stack, Text } from "@mantine/core";
import { PortalNotificationPreference } from "../../../services/admin/portalAccess.service";
import { PortalNotificationPreferenceBadge } from "./PortalNotificationPreferenceBadge";

interface PortalNotificationPreferenceSummaryProps {
  preference: PortalNotificationPreference;
  lastDigestSentAt: string | null;
}

function formatDigestTime(value: string): string {
  return new Date(value).toLocaleString();
}

export function PortalNotificationPreferenceSummary({
  preference,
  lastDigestSentAt,
}: PortalNotificationPreferenceSummaryProps) {
  const includesDailyDigest = useMemo(
    () => preference === "daily_digest" || preference === "both",
    [preference]
  );

  return (
    <Stack gap={4} align="flex-start" style={{ minWidth: "max-content" }}>
      <PortalNotificationPreferenceBadge preference={preference} />
      {includesDailyDigest && (
        <Text size="xs" c="dimmed" style={{ whiteSpace: "nowrap" }}>
          {lastDigestSentAt
            ? `Last digest: ${formatDigestTime(lastDigestSentAt)}`
            : "\u00A0"}
        </Text>
      )}
    </Stack>
  );
}
